import { Icon, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { messageError } from '../../utils';

interface EquityLastPriceProps {
  lastPrice: number | null;
  priceChangeTax: number | null;
  tradeDate: Date;
}

export const EquityLastPrice: React.FC<Partial<EquityLastPriceProps>> = ({
  lastPrice,
  priceChangeTax,
  tradeDate,
}) => {
  const priceChangeTaxIsPositive = priceChangeTax && priceChangeTax >= 0;
  const iconColorPositive = 'feedback.success.default';
  const iconColorNegative = 'feedback.error.default';
  const iconColor = priceChangeTaxIsPositive ? iconColorPositive : iconColorNegative;
  const tradeDateFormatted = tradeDate
    ? `Atualizado às ${Utils.Mask.DateFormat(tradeDate, 'HH:mm')}`
    : messageError;

  return (
    <VStack>
      <HStack space={Spacing['inline.nano']} alignItems={'center'}>
        <Text variant="regular" color={'neutral.darkest'}>
          {Utils.Mask.Money(lastPrice || 0)}
        </Text>
        <HStack alignItems={'center'} justifyContent={'center'}>
          {priceChangeTax !== 0 && (
            <Icon
              name={priceChangeTaxIsPositive ? 'ArrowUp' : 'ArrowDown'}
              size="xxxxxs"
              color={Color[iconColor]}
              testID="last-price-arrow"
            />
          )}
          <Text
            variant="regular"
            color={priceChangeTax === 0 ? 'neutral.black' : iconColor}
            fontSize={Typography['fontsize.md']}>
            {Utils.Mask.Percentage(priceChangeTax || 0)}
          </Text>
        </HStack>
      </HStack>
      <Text variant="regular" color={'neutral.medium'} fontSize={Typography['fontsize.xs']}>
        {tradeDateFormatted}
      </Text>
    </VStack>
  );
};
